export default __webpack_public_path__ + "static/media/melhorias-qualidade-reunioes.14828b7b.svg";